import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'sheets';

import styles from './Panel.css';

const Panel = (props) => {
  const toggle = () => {
    props.toggle(props.type, props.id, !props.show, props.title);
  };

  const handleKeyPress = (e) => {
    const keyCode = e.which || e.keyCode;

    if (keyCode === 13) {
      toggle();
    }
  };

  const minusIconClass = props.show ? styles[`icon`] : styles[`icon-minus--hide`];
  const plusIconClass = props.show ? styles[`icon-plus--hide`] : styles[`icon`];
  const itemContentClass = props.show ? styles[`item-content`] : styles[`item-content--hidden`];

  return (
    <li
      className={styles[`item`]}
      onClick={toggle}
      onKeyPress={handleKeyPress}
      role="menuitem"
      tabIndex="0"
    >
      <div className={styles[`section`]}>
        <span className={styles[`icon-container`]}>
          <Icon
            className={minusIconClass}
            name="minus"
          />
          <Icon
            className={plusIconClass}
            name="plus"
          />
        </span>
        <span className={styles[`section-title`]}>
          {props.title}
        </span>
      </div>
      <div className={styles[`content-container`]}>
        <p
          className={itemContentClass}
          dangerouslySetInnerHTML={{__html: props.content}}
        />
      </div>
    </li>
  );
};

Panel.propTypes = {
  content: PropTypes.string.isRequired,
  id: PropTypes.number,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
  toggle: PropTypes.func,
  type: PropTypes.string,
};

export default Panel;
